import { TrendingDown, FileDown, Save, Sparkles, ShieldCheck } from "lucide-react";
import { COMPANY } from "@/data/services";

export default function ProHero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 to-emerald-50/40 dark-bg-section border-b border-slate-200 dark-border">
      <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />
      <div className="container mx-auto px-4 md:px-8 py-10 md:py-14 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-4 mb-5">
              <img
                src={COMPANY.logo}
                alt={COMPANY.name}
                className="w-14 h-14 md:w-16 md:h-16 rounded-xl object-contain bg-white border border-slate-200 dark-border shadow-sm p-1"
              />
              <div>
                <div className="font-display font-bold text-slate-900 dark-text-strong text-xl md:text-2xl leading-tight">{COMPANY.name}</div>
                <div className="text-emerald-700 dark-text-accent text-sm italic">{COMPANY.slogan}</div>
              </div>
            </div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-100 dark-bg-pill border border-emerald-200/60 dark-border text-[11px] font-semibold uppercase tracking-[0.2em] text-emerald-700 dark-text-accent mb-4">
              <Sparkles className="w-3.5 h-3.5" />
              Presupuesto profesional para tu cliente
            </div>
            <h1 className="font-display font-bold text-slate-900 dark-text-strong text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tighter">
              Genera un presupuesto detallado, <br className="hidden sm:block" />
              <span className="text-emerald-600">claro y a medida</span> para entregar al cliente.
            </h1>
            <p className="mt-4 text-slate-600 dark-text-mid text-base max-w-2xl leading-relaxed">
              Configura las partidas, ajusta precios sin perder rentabilidad y exporta un <strong className="text-slate-900 dark-text-strong">PDF profesional</strong> con tu marca, datos de empresa, desglose completo, IVA, condiciones y garantía.
            </p>

            <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3 max-w-2xl">
              <Bullet icon={TrendingDown} text="Estándar / Optimizado por partida" />
              <Bullet icon={Sparkles} text="Aviso si bajas de la media" />
              <Bullet icon={Save} text="Guarda múltiples presupuestos" />
              <Bullet icon={FileDown} text="PDF con tu marca y firma" />
            </div>
          </div>

          {/* Tarjeta de empresa */}
          <aside className="lg:col-span-4">
            <div className="rounded-2xl bg-slate-900 dark-bg-card-strong text-white p-6 shadow-[0_20px_60px_-20px_rgba(15,23,42,0.5)]">
              <div className="flex items-center gap-2 text-emerald-300 mb-3">
                <ShieldCheck className="w-4 h-4" />
                <span className="text-[10px] uppercase tracking-[0.2em] font-semibold">Empresa registrada</span>
              </div>
              <div className="font-display font-bold text-lg leading-tight">{COMPANY.name}</div>
              <div className="text-slate-300 text-sm mt-1">{COMPANY.tagline}</div>
              <div className="text-slate-400 text-xs mt-1">{COMPANY.area}</div>

              <div className="mt-5 space-y-2 text-xs">
                <Info label="Tel / WhatsApp" value={COMPANY.whatsappFormatted} />
                <Info label="Email" value={COMPANY.email} />
                <Info label="Web" value={COMPANY.website} />
                <Info label="Instagram" value={`@${COMPANY.instagram}`} />
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

function Bullet({ icon: Icon, text }) {
  return (
    <div className="flex items-start gap-2 p-3 rounded-lg bg-white dark-bg-card border border-slate-200 dark-border">
      <div className="w-7 h-7 rounded bg-emerald-100 dark-bg-pill text-emerald-700 dark-text-accent grid place-items-center shrink-0">
        <Icon className="w-3.5 h-3.5" />
      </div>
      <div className="text-xs text-slate-700 dark-text-mid leading-snug">{text}</div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div className="flex items-baseline justify-between gap-3 border-b border-white/10 pb-1.5">
      <span className="text-slate-400 uppercase tracking-wider text-[10px]">{label}</span>
      <span className="text-white font-medium text-right">{value}</span>
    </div>
  );
}
